module.exports = "https://static.wagwalking.com/_next/static/images/paws-e5024e581bd40eec3660ff963073e1a1.svg";